
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quiz",
      function () {
        return require("private-next-pages/quiz/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quiz"])
      });
    }
  